import React, { useState } from 'react';
import _ from 'lodash';
import { SearchInput } from '@spins/react-ui-library';
import InfiniteScroll from 'react-infinite-scroll-component';
import './styles.scss';

type ItemType = {
  firstLabel: string;
  secondLabel?: string;
};

interface Props {
  items: Array<ItemType>;
  title?: string;
}

const CampaignsModalItemSelection: React.FC<Props> = ({ items, title = null }) => {
  const [searchText, setSearchText] = useState('');

  const filterAndSortItems = (items) => {
    let result = items.filter(
      (item) =>
        searchText === '' ||
        item.firstLabel.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
        (item.secondLabel && item.secondLabel.toLowerCase().indexOf(searchText.toLowerCase()) > -1)
    );
    return _.orderBy(result, ['firstLabel']);
  };

  return (
    <div className="modal-item-selection">
      <div>{title !== null && <div className="title">{title}</div>}</div>
      <div>
        <SearchInput
          className="search-field"
          placeholder="Search..."
          onChange={(search) => setSearchText(search)}
        />
      </div>
      <div className="all-items-container">
        <div id="infiniteScroll">
          <InfiniteScroll
            dataLength={items.length}
            hasMore={true}
            height={300}
            next={null}
            loader={false}
          >
            {filterAndSortItems(items).map((item, index) => {
              return (
                <div key={index} className="item-container">
                  <div>{item.firstLabel}</div>
                  {item.secondLabel ? <div className="second-label">{item.secondLabel}</div> : null}
                </div>
              );
            })}
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
};

export default CampaignsModalItemSelection;
